import React from "react";
import PanCardIcon from "../../assets/images/PanCardIcon";
import BankDetailsIcon from "../../assets/images/BankDetailsIcon";
import DrivingLicenseIcon from "../../assets/images/DrivingLicenseIcon";
import Button from "./cta/Button";
import {
  DisableVerifyStaffButton,
  VerifyStaffButton,
} from "./styles/CommonStyles";
import { OnboardConstants } from "../../constants/constants";
import DrivingLicenseIconWithWhiteBG from "../../assets/images/DrivingLicenseIconWithWhiteBG";
import BankDetailsIconWithWhiteBG from "../../assets/images/BankDetailIconWithWhiteBG";
import PanCardIconWithWhiteBG from "../../assets/images/PanCardIconWithWhiteBG";
import DoneIcon from "../../assets/images/DoneIcon";
interface StaffVerifyTileProps {
  title: string;
  showVerify: boolean;
  isVerifed: boolean;
  handleVerifyButtonChange: (title: string) => void;
  handleSelectedTileChange: (title: string) => void;
  backgroundColor?: string;
  activeTile?: string;
  userInfo: any;
  setVerifyTitle: (title: string) => void;
  setShowVerifyButton: (showVerify: boolean) => void;
  showOr?: any;
}
const StaffVerifyTile = ({
  title,
  showVerify,
  handleVerifyButtonChange,
  handleSelectedTileChange,
  backgroundColor,
  activeTile,
  isVerifed,
  userInfo,
  setShowVerifyButton,
  setVerifyTitle,
  showOr,
}: StaffVerifyTileProps) => {
  const getIcon = (
    verified: boolean,
    isActive: boolean,
    defaultIcon: React.ComponentType,
    activeIcon: React.ComponentType
  ) => {
    if (verified) return DoneIcon;
    return isActive ? activeIcon : defaultIcon;
  };
  const componentMap: Record<string, React.ComponentType<any>> = {
    "Driving License": getIcon(
      isVerifed,
      activeTile === title,
      DrivingLicenseIcon,
      DrivingLicenseIconWithWhiteBG
    ),
    "Bank Details": getIcon(
      isVerifed,
      activeTile === title,
      BankDetailsIcon,
      BankDetailsIconWithWhiteBG
    ),
    "PAN Card": getIcon(
      isVerifed,
      activeTile === title,
      PanCardIcon,
      PanCardIconWithWhiteBG
    ),
  };

  const verificationMessage: Record<
    string,
    { pre: string; bold: string; post: string }
  > = {
    "Driving License": {
      pre: OnboardConstants.dlVerifiedSuccessMessage,
      bold: userInfo?.professionalDetails?.drivingLicenceNumber,
      post: OnboardConstants.successMessage,
    },
    "Bank Details": {
      pre: OnboardConstants.bankVerifiedSuccessMessage,
      bold: userInfo?.bankDetails?.accountNumber,
      post: OnboardConstants.successMessage,
    },
    "PAN Card": {
      pre: OnboardConstants.panVerifiedSuccessMessage,
      bold: userInfo?.bankDetails?.panNumber,
      post: OnboardConstants.successMessage,
    },
  };

  const SelectedComponent = componentMap[title];
  setVerifyTitle(activeTile ?? "");
  setShowVerifyButton(showVerify);
  return (
    <div className="flex items-center">
      <div>
        {showOr && (
          <div className="mx-2 ml-7 mt-8 font-semibold text-blackColor text-lg">
            OR
          </div>
        )}
      </div>
      <div
        data-testId={title}
        className={`mt-6 pt-3 md:pt-6 rounded-lg border border-border ml-6 h-[175px] md:h-[214px] w-full ${backgroundColor}`}
        onClick={showVerify ? () => handleSelectedTileChange(title) : undefined}
      >
        <div className="  flex flex-col items-center   ">
          <div
            className={` flex flex-col ${isVerifed && "h-[32px]"} items-center`}
          >
            {SelectedComponent && <SelectedComponent />}
          </div>

          <div className="text-dashBoardTileCountColor tableTitle md:consentSubmitButton font-nunito mt-3 md:mt-4">
            {title}
          </div>
          {isVerifed && (
            <div className="documentUploadText text-center font-nunito mt-3 md:mt-4 px-1">
              {verificationMessage[title].pre}{" "}
              <b>{verificationMessage[title].bold}</b>{" "}
              {verificationMessage[title].post}
            </div>
          )}
          {!isVerifed && activeTile !== title && (
            <div className="mb-6" data-testId={`${title} verify`}>
              <Button
                handleClick={
                  showVerify ? () => handleVerifyButtonChange(title) : () => {}
                }
                buttonText={OnboardConstants.verify}
                className={
                  showVerify ? VerifyStaffButton : DisableVerifyStaffButton
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StaffVerifyTile;
